export function getDeferredPromise<T>(): {
  resolve: (value: (PromiseLike<T> | T)) => void;
  reject: (reason?: any) => void;
  promise: Promise<T>
} {
  let resolve: (value: T | PromiseLike<T>) => void;
  let reject: (reason?: any) => void;

  const promise: Promise<T> = new Promise<T>((rs, rj) => {
    resolve = rs;
    reject = rj;
  });

  return {resolve, reject, promise};
}
